import anime from 'animejs/lib/anime.es.js';

// Logo Animation function - petals expand from center
export function animateLogo() {
    // Get all the elements we need
    const petals = document.querySelectorAll('#Logo path');
    const logoGroup = document.querySelector('#Logo');
    
    // Define the center coordinates of the SVG
    const centerX = 19.5; // Center X of the viewBox (39/2)
    const centerY = 20.5; // Center Y of the viewBox (41/2)
    
    // Calculate vectors representing the direction each petal needs to move
    // These vectors point from the center to where each petal should end up
    // Updated to match the new SVG petal order
    const petalVectors = [
        // Petal 1 (top right)
        { x: 6, y: -8 },
        // Petal 2 (right)
        { x: 12, y: 0 },
        // Petal 4 (bottom left)
        { x: -6, y: 8 },
        // Petal 3 (bottom right)
        { x: 6, y: 8 },
        // Petal 5 (left)
        { x: -12, y: 0 },
        // Petal 6 (top left)
        { x: -6, y: -8 }
    ];
    
    // Set initial positions for each petal - they start much closer to the center
    petals.forEach((petal, index) => {
        // Move each petal 95% toward the center from its final position
        anime.set(petal, {
            translateX: -petalVectors[index].x * 0.95,
            translateY: -petalVectors[index].y * 0.95,
            opacity: 0 // Start completely transparent
        });
    });
    
    // Create the animation timeline
    const timeline = anime.timeline({
        easing: 'easeOutQuad'
    });
    
    // Custom ultra-gentle easing function for blooming effect
    const bloomEasing = (t) => {
        // Very gentle start with a more pronounced finish
        return 0.05 * Math.sin(Math.PI * t) + t * (1 - 0.05 * Math.sin(Math.PI));
    };
    
    // Animate each petal outward extremely slowly and gently
    timeline.add({
        targets: petals,
        translateX: 0,
        translateY: 0,
        opacity: [
            { value: 0, duration: 0 },
            { value: 0.3, duration: 800 },
            { value: 1, duration: 2000 }
        ], // Gradual fade-in with delayed start
        duration: 1000, // Duration for the gentle opening
        delay: anime.stagger(250), // Longer stagger for a more natural blooming effect
        easing: 'easeInOutSine' // Ultra-gentle easing curve
    }, 0);
    
    return timeline;
}

// Initialize when the DOM is ready
export function initLogoAnimation() {
    // Set the transform origin to the center
    const logoElement = document.querySelector('#Logo');
    if (logoElement) {
        anime.set(logoElement, {
            transformOrigin: 'center'
        });
        
        // Start the animation
        const animation = animateLogo();
        
        // Add replay button functionality
        const replayButton = document.getElementById('replay-button');
        if (replayButton) {
            replayButton.addEventListener('click', () => {
                animation.restart();
            });
        }
        
        return animation;
    }
}